export { formatCurrency as default } from 'choerodon-ui/dataset';
